<template>
  <div id="contenedor-agregar-tipo-archivo-contratista">
    <v-form v-model="formularioValido" ref="formAgregarTipoArchivoContratista">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar tipo de archivo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Descripción"
            v-model="tipoArchivo.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Orden"
            v-model.number="tipoArchivo.orden"
            :rules="[mixReglas.requerido]"
            type="number"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixAgregarTipoArchivoContratista"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixTipoArchivosContratista from './mixTipoArchivosContratista';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarTipoArchivoContratista',
  mixins: [mixTipoArchivosContratista],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipoArchivo: {
        descripcion: '',
        orden: 0,
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.formAgregarTipoArchivoContratista.reset();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
